import styled from 'styled-components';
import { theme } from '@/theme/Theme';

const PolicyWrapper = styled.div<{ isMobile: boolean }>`
  width: 100%;
  position: fixed;
  z-index: 1000;
  bottom: ${({ isMobile }) => isMobile ? '0' : '-200px'};

  .cover {
    width: ${({ isMobile }) => isMobile ? '100vw' : 'unset'};
    height: ${({ isMobile }) => isMobile ? '100vh' : 'unset'};
    background: rgba(0, 0, 0, 0.5);

    .content {
      width: ${({ isMobile }) => isMobile ? '80%' : '100%'};
      border: ${({ isMobile }) => isMobile ? 'none' : '1px solid black'};
      border-radius: ${({ isMobile }) => isMobile ? '10px 10px 10px 0' : '0'};
      background: #fff;
      padding: ${({ isMobile }) => isMobile ? '25px 20px' : '25px 100px 20px 20px'};
      position: ${({ isMobile }) => isMobile ? 'fixed' : 'unset'};
      // 手機板則將此樣板置中
      left: ${({ isMobile }) => isMobile ? '50%' : '0'};
      bottom: ${({ isMobile }) => isMobile ? '50%' : '0'};
      transform: ${({ isMobile }) => isMobile ? 'translate(-50%, 50%)' : 'translateY(0)'};
      color: ${theme.colors.gray500};
      }
  }



  // 增加展開時和點擊關閉時的動畫效果
  transition: ${({ isMobile }) => isMobile ? 'all 0s ease' : 'all 1s ease'};

  &.active {
    bottom: 0;
  }

  &.hidden {
    display: none;
  }
`;

const CloseBtn = styled.button<{ isMobile: boolean }>`
  position: absolute;
  right: ${({ isMobile }) => isMobile ? '5px' : '20px'};
  top: ${({ isMobile }) => isMobile ? '5px' : '20px'};
  cursor: pointer;
`

export { PolicyWrapper, CloseBtn };
